const { default: getFrontConfig } = require('../../common/getFrontConfig');

const {
  checkout: { adyenPaymentMethods },
} = getFrontConfig();

module.exports = {
  billing: {
    BILLING_ADDRESS_BLOCK_SELECTOR: '.billing-address-block',
    BILLING_ADDRESS_FORM_ERROR_SELECTOR: '.submit-billing-error',
    BILLING_ADDRESS_FORM_SELECTOR: '#dwfrm_billing',
    BILLING_ADDRESS_SELECTOR: '.billing-address',
    BILLING_ADDRESS_SELECTOR_SELECTOR: '.billing-selector-block',
  },
  paymentMethod: {
    ADYEN_PAYMENTS_WITHOUT_DETAILS: [adyenPaymentMethods.SOFORT.type],
    MAIN_PAYMENT_SESSION_ATTR: 'selectedPaymentMethod',
  },
};
